import { customElement, FASTElement, html, ref } from '@genesislcap/web-core';

@customElement({
  name: 'bond-data-import',
  template: html`
    <rapid-button appearance="primary" type="button" @click=${(x) => x.openFileDialog()}>Import from csv</rapid-button>
    <input 
      ${ref('fileInput')}
      type="file" 
      accept=".csv" 
      @change=${(x, c) => x.onImportFile(c.event)} 
      style="display: none;" 
    />
  `,
})
export class BondDataImport extends FASTElement {
  fileInput!: HTMLInputElement;

  openFileDialog() {
    this.fileInput?.click();
  }

  onImportFile(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target?.result as string;
      // Simple CSV parsing (assumes header row and comma delimiter)
      const lines = text.split('\n').filter(line => line.trim() !== '');
      if (lines.length < 2) return;
      const headers = lines[0].split(',').map(h => h.trim());
      const rowData = lines.slice(1).map(line => {
        const cols = line.split(',');
        const obj: any = {};
        headers.forEach((header, i) => {
          obj[header] = cols[i]?.trim();
        });
        return obj;
      });
      // Emit event with parsed data
      const customEvent = new CustomEvent('csv-data-imported', {
        detail: rowData,
        bubbles: true,
        composed: true,
      });
      this.dispatchEvent(customEvent);
      
      // Clear the file input so the same file can be selected again
      this.fileInput.value = '';
    };
    reader.readAsText(file);
  }
} 